import { createStyles } from '@material-ui/styles'
const inputBox = '70px'

export default () =>
    createStyles({
        forum: {
            height: '100%',
            paddingLeft: 0,
            paddingRight: 0,
            backgroundColor: '#1c222e',
            display: 'flex',
            flexDirection: 'column',
            '@media (max-width: 767px)': {
                width: '100%',
                maxWidth: 'inherit',
            },
        },

        fullScreen: {
            maxWidth: '100% !important',
            backgroundColor: 'transparent',
        },

        emptyText: {
            color: 'white',
        },

        dark: {
            minWidth: '85%',
            border: 'none',
            borderRadius: 3,
            paddingLeft: 10,
            backgroundColor: '#2e3747',
            height: 40,
            '&:focus': {
                backgroundColor: '#2e3747',
                outline: 'none',
            },
        },

        forumEntries: {
            padding: '20px 16px 10px',
            webkitOverflowScrolling: 'touch',
            width: '100%',
            height: '100%',
            overflowY: 'scroll',
            marginBottom: inputBox,
        },

        inputGroup: {
            justifyContent: 'space-between',
        },

        removePadding: {},
        forumInput: {
            width: '100%',
            position: 'fixed',
            bottom: 0,
            maxWidth: '100%',
            padding: 15,
            '& p:first-of-type': {
                marginBottom: 0,
            },
            '@media (max-width: 767px)': {
                '& > p': {
                    fontSize: 11,
                    marginBottom: 5,
                },
            },
            '@media (min-width: 768px)': {
                position: 'absolute',
            },

            '&$removePadding': {
                padding: 0,
            },
        },

        submitBtn: {
            '@media (min-width: 768px)': {
                display: 'none',
            },
        },

        forumTabs: {
            '@media (max-width: 767px)': {
                display: 'none',
            },
        },

        refreshQuestions: {
            position: 'absolute',
            transform: 'translateY(85px)',
            boxShadow: 'rgba(0, 0, 0, 0.6) 1px 2px 4px',
            alignSelf: 'center',
            zIndex: 1,

            '@media (max-width: 767px)': {
                transform: 'translateY(32px)',
            },
        },
    })
